//export const AUTH_CONFIG = {
//    domain: 'mhss-dev.auth0.com',
//  clientId: 'D4CeC3omBboDIX2fbfm2G3OEcwb6Av7J',
//    callbackUrl: 'http://dev.chartaudits.com/callback',
//    API_URL: 'http://dev-api.chartaudits.com',
//  AUTH0_AUDIENCE: 'mhss-api-dev'
//}
//export const AUTH_CONFIG = {
//    domain: 'ertools.auth0.com',
//    clientId: 'gi7QmgxRUN139eNwOw6gkqvpWaetzbey',
//    callbackUrl: 'https://localhost:44342/callback',
//    logOutUrl: 'https://localhost:44342/signup',
//    currentUrl:'https://localhost:44342/',
//    API_URL: 'http://localhost:3010',
//    AUTH0_AUDIENCE: 'ertools-api-dev',
//    CDN_URL:'https://teamsly-cdn-cuc0cvgwakbtarf9.z01.azurefd.net'
//}
export const AUTH_CONFIG = {
    API_URL: process.env.REACT_APP_API_URL,
    CurrentUrl: process.env.REACT_APP_CurrentUrl,
    CDN_URL: process.env.REACT_APP_CDN_URL,
}


//57604